import icons from '@/assets/icons';
import { Box, BoxProps, Image } from '@cmpsr/components';
import { TypeOfCancer, TypeOfCancerIcon } from './types';

export type IconCatchProps = {
  icon: keyof typeof icons;
  alt?: string;
  size?: 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';
} & BoxProps;

const measures = {
  xs: '20px',
  s: '30px',
  m: '44px',
  l: '50px',
  xl: '70px',
  xxl: '100px',
};

export default function IconCatch({ icon, alt, size = 'l', filter, ...props }: IconCatchProps) {
  return (
    <Box as="figure" borderRadius="radii-2" bgColor="background-card" w={measures[size]} h={measures[size]} {...props}>
      <Image
        src={icons[icon]}
        alt={alt ?? ''}
        w="full"
        sx={
          filter
            ? {
                filter,
              }
            : {}
        }
      />
    </Box>
  );
}

export const findIcon = (iconName: string): keyof typeof icons => {
  const foundInObjectIcon = TypeOfCancerIcon[iconName.toLowerCase() as TypeOfCancer] || null;

  if (foundInObjectIcon) return foundInObjectIcon;

  const foundThroughTextIcon = Object.keys(icons).find((iconKey) =>
    iconKey.toLowerCase().includes(iconName.toLowerCase())
  ) as keyof typeof icons;
  return foundThroughTextIcon;
};
